package com.milta.feature.team.domain.entity

data class Driver(
    val id: String,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
)
